import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';
import { BASE_URL } from './Components/common/constants';
import { isExpired, decodeToken } from "react-jwt";
import { useDispatch } from 'react-redux';
import { initFocusTimer } from './redux/slices/timer';
import { setFocusTasksList } from './redux/slices/TaskSlice';

const SocketContext = createContext();

export const useSocket = () => {
  return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [focusTimerMeta, setFocusTimerMeta] = useState(null);
  const [load, setLoad] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const newSocket = io(BASE_URL, {
        auth: { token }
    }); // Adjust according to your server URL
    setSocket(newSocket);

    if(newSocket !== null && token){
      const user = decodeToken(token);
     
      newSocket.emit('focusTimerInit', {room: user['outseta:accountUid'], data: {action: 'fetchFocusTimer'}}, (response) => {
        //console.log('socket response', response);
        const {isSessionActive, clientCount} = response;

        if(clientCount > 1 || !isSessionActive){
          dispatch(initFocusTimer({retainFocusSessions: true}));
          dispatch(setFocusTasksList([]));
          setFocusTimerMeta({isSessionActive, clientCount});
        }

       // setLoad(true);
      });
    }
    
    return () => newSocket.close();
  }, []);

  return (
    <SocketContext.Provider value={{socket, focusTimerMeta}}>
      {load ? children : null}
    </SocketContext.Provider>
  );
};